export enum AlertVariant {
    "NewPages",
    "NewKeywords",
    "All",
    "SocialPosts",
    "WebsiteContent",
}
export enum AlertGroup {
    "Organic",
    "Paid",
}

export type Granularity = "Daily" | "Weekly" | "Monthly";
